// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"91":"495a020382724eb0","844":"e33aba373aa330eb"}[chunkId] + ".js";
};